<template>
  <card>
    <h2 slot="header" class="card-title">{{$t('clarifications.requests')}}</h2>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div></div>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                label="Application Reference"
                property="application.reference"
                prop="application.reference"
              ></el-table-column>
              <el-table-column
                label="Last Question By"
              >
                <div slot-scope="props">
                  <span v-if="props.row.questions[props.row.questions.length-1]">
                  {{props.row.questions[props.row.questions.length-1].author_question.name}}
                    </span>
                </div>
              </el-table-column>
              <el-table-column
                label="Questions"
              >
                <div slot-scope="props">
                  {{props.row.questions.length}}
                </div>
              </el-table-column>
              <el-table-column
                label="Last Question"
              >
                <div slot-scope="props">
                  <span v-if="props.row.questions[props.row.questions.length-1]">
                  {{props.row.questions[props.row.questions.length-1].created_at}}
                    </span>
                </div>
              </el-table-column>
              <el-table-column
                label="Last Answer"
              >
                <div slot-scope="props">
                  <span v-if="props.row.questions[props.row.questions.length-1]">
                  {{props.row.questions[props.row.questions.length-1].answered_at}}
                    </span>
                </div>
              </el-table-column>
              <el-table-column align="right" label="Actions">
                <div slot-scope="props">
                  <base-button
                    type="info"
                    size="sm"
                    class="mb-1 mr-2"
                    @click="viewClarification(props.row)"
                  >
                    View
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </card>
</template>
<script>
  import {Table, TableColumn} from 'element-ui';
  import {BasePagination} from 'src/components';
  import Fuse from 'fuse.js';
  import {ClarificationService} from "@/services";

  export default {
    components: {
      BasePagination,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    computed: {
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 10000,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        initialized: false,
      };
    },
    methods: {
      viewClarification(data) {
        this.$router.push('/clarifications/fill/' + data.application_id);
      },
      async getClarifications() {
        let vm = this;
        return await ClarificationService.all().then(function (response) {
          vm.tableData = response.data;
        })
      },
      initFuse() {
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      },
    },
    async mounted() {
      let vm = this;
      let loader = vm.$loading.show();
      await vm.getClarifications();
      vm.initFuse();
      loader.hide();

    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      }
    }
  };
</script>